import React from 'react';

import { FILTER_OPTIONS } from '@api/articles/constants';
import { ROLE } from '@api/users/constants';

import useUserRole from './useUserRole';

const useArticleFilterOptions = () => {
  const role = useUserRole();

  const types = React.useMemo(() => {
    if (role === ROLE.EDITOR) {
      return FILTER_OPTIONS;
    }
    return FILTER_OPTIONS.filter(
      ({ visibleFor }) => !visibleFor || visibleFor.length === 0 || visibleFor.includes(role),
    );
  }, [role]);

  return types;
};

export default useArticleFilterOptions;
